/**
 * Full character art mapping
 * Maps character IDs to their commissioned artwork in multiple sizes
 */

const CHARACTER_ART = {
  "cruz": {
    "main": {
      "full": "/art/characters/cruz_full.png",
      "medium": "/art/characters/cruz_medium.png",
      "thumb": "/art/characters/cruz_thumb.png"
    },
    "alts": {
      "cruz_gold": {
        "medium": "/art/characters/cruz_gold_medium.png",
        "thumb": "/art/characters/cruz_gold_thumb.png"
      },
      "cruz_main_sprite": {
        "full": "/art/characters/cruz_main_full.png",
        "medium": "/art/characters/cruz_main_medium.png",
        "thumb": "/art/characters/cruz_main_thumb.png"
      },
      "cruz_bedroom": {
        "full": "/art/characters/cruz_bedroom_full.png",
        "medium": "/art/characters/cruz_bedroom_medium.png",
        "thumb": "/art/characters/cruz_bedroom_thumb.png"
      },
      "cruz_gacha": {
        "full": "/art/characters/cruz_gacha_full.png",
        "medium": "/art/characters/cruz_gacha_medium.png",
        "thumb": "/art/characters/cruz_gacha_thumb.png"
      },
      "cruz_relaxed": {
        "full": "/art/characters/cruz_relaxed_full.png",
        "medium": "/art/characters/cruz_relaxed_medium.png",
        "thumb": "/art/characters/cruz_relaxed_thumb.png"
      },
      "cruz_walkman": {
        "full": "/art/characters/cruz_walkman_full.png",
        "medium": "/art/characters/cruz_walkman_medium.png",
        "thumb": "/art/characters/cruz_walkman_thumb.png"
      }
    }
  },
  "alistair": {
    "main": {
      "full": "/art/characters/alistair_full.png",
      "medium": "/art/characters/alistair_medium.png",
      "thumb": "/art/characters/alistair_thumb.png"
    },
    "alts": {
      "alistair_alt": {
        "medium": "/art/characters/alistair_alt_medium.png",
        "thumb": "/art/characters/alistair_alt_thumb.png"
      }
    }
  },
  "kya_sg1": {
    "main": {
      "full": "/art/characters/kya_sg1_full.png",
      "medium": "/art/characters/kya_sg1_medium.png",
      "thumb": "/art/characters/kya_sg1_thumb.png"
    },
    "alts": {
      "kya_siren": {
        "medium": "/art/characters/kya_siren_medium.png",
        "thumb": "/art/characters/kya_siren_thumb.png"
      },
      "kya_alt": {
        "medium": "/art/characters/kya_alt_medium.png",
        "thumb": "/art/characters/kya_alt_thumb.png"
      }
    }
  },
  "val": {
    "main": {
      "full": "/art/characters/val_full.png",
      "medium": "/art/characters/val_medium.png",
      "thumb": "/art/characters/val_thumb.png"
    },
    "alts": {
      "val_red": {
        "medium": "/art/characters/val_red_medium.png",
        "thumb": "/art/characters/val_red_thumb.png"
      }
    }
  },
  "evelyn": {
    "main": {
      "full": "/art/characters/evelyn_full.png",
      "medium": "/art/characters/evelyn_medium.png",
      "thumb": "/art/characters/evelyn_thumb.png"
    },
    "alts": {
      "evelyn_alt": {
        "medium": "/art/characters/evelyn_alt_medium.png",
        "thumb": "/art/characters/evelyn_alt_thumb.png"
      },
      "evelyn_red": {
        "medium": "/art/characters/evelyn_red_medium.png",
        "thumb": "/art/characters/evelyn_red_thumb.png"
      }
    }
  },
  "raye": {
    "main": {
      "full": "/art/characters/raye_full.png",
      "medium": "/art/characters/raye_medium.png",
      "thumb": "/art/characters/raye_thumb.png"
    },
    "alts": {
      "raye_red": {
        "medium": "/art/characters/raye_red_medium.png",
        "thumb": "/art/characters/raye_red_thumb.png"
      }
    }
  },
  "raz": {
    "main": {
      "full": "/art/characters/raz_full.png",
      "medium": "/art/characters/raz_medium.png",
      "thumb": "/art/characters/raz_thumb.png"
    },
    "alts": {
      "raz_red": {
        "medium": "/art/characters/raz_red_medium.png",
        "thumb": "/art/characters/raz_red_thumb.png"
      }
    }
  },
  "ryder": {
    "main": {
      "full": "/art/characters/ryder_full.png",
      "medium": "/art/characters/ryder_medium.png",
      "thumb": "/art/characters/ryder_thumb.png"
    },
    "alts": {
      "ryder_sadistic": {
        "medium": "/art/characters/ryder_sadistic_medium.png",
        "thumb": "/art/characters/ryder_sadistic_thumb.png"
      }
    }
  },
  "rowan": {
    "main": {
      "full": "/art/characters/rowan_full.png",
      "medium": "/art/characters/rowan_medium.png",
      "thumb": "/art/characters/rowan_thumb.png"
    }
  },
  "nolan": {
    "main": {
      "full": "/art/characters/nolan_full.png",
      "medium": "/art/characters/nolan_medium.png",
      "thumb": "/art/characters/nolan_thumb.png"
    }
  },
  "lucius": {
    "main": {
      "full": "/art/characters/lucius_full.png",
      "medium": "/art/characters/lucius_medium.png",
      "thumb": "/art/characters/lucius_thumb.png"
    },
    "alts": {
      "lucius_angry": {
        "medium": "/art/characters/lucius_angry_medium.png",
        "thumb": "/art/characters/lucius_angry_thumb.png"
      },
      "lucius_rage": {
        "medium": "/art/characters/lucius_rage_medium.png",
        "thumb": "/art/characters/lucius_rage_thumb.png"
      }
    }
  },
  "audrey": {
    "main": {
      "full": "/art/characters/audrey_full.png",
      "medium": "/art/characters/audrey_medium.png",
      "thumb": "/art/characters/audrey_thumb.png"
    }
  },
  "lily": {
    "main": {
      "full": "/art/characters/lily_full.png",
      "medium": "/art/characters/lily_medium.png",
      "thumb": "/art/characters/lily_thumb.png"
    }
  },
  "bryce": {
    "main": {
      "full": "/art/characters/bryce_full.png",
      "medium": "/art/characters/bryce_medium.png",
      "thumb": "/art/characters/bryce_thumb.png"
    },
    "alts": {
      "bryce_red": {
        "medium": "/art/characters/bryce_red_medium.png",
        "thumb": "/art/characters/bryce_red_thumb.png"
      }
    }
  },
  "dimitri": {
    "main": {
      "full": "/art/characters/dimitri_full.png",
      "medium": "/art/characters/dimitri_medium.png",
      "thumb": "/art/characters/dimitri_thumb.png"
    },
    "alts": {
      "dimitri_red": {
        "medium": "/art/characters/dimitri_red_medium.png",
        "thumb": "/art/characters/dimitri_red_thumb.png"
      }
    }
  },
  "lance": {
    "main": {
      "full": "/art/characters/lance_full.png",
      "medium": "/art/characters/lance_medium.png",
      "thumb": "/art/characters/lance_thumb.png"
    }
  },
  "pierce": {
    "main": {
      "full": "/art/characters/pierce_full.png",
      "medium": "/art/characters/pierce_medium.png",
      "thumb": "/art/characters/pierce_thumb.png"
    },
    "alts": {
      "pierce_gold": {
        "medium": "/art/characters/pierce_gold_medium.png",
        "thumb": "/art/characters/pierce_gold_thumb.png"
      }
    }
  },
  "moros": {
    "main": {
      "full": "/art/characters/moros_full.png",
      "medium": "/art/characters/moros_medium.png",
      "thumb": "/art/characters/moros_thumb.png"
    },
    "alts": {
      "moros_flame": {
        "medium": "/art/characters/moros_flame_medium.png",
        "thumb": "/art/characters/moros_flame_thumb.png"
      }
    }
  },
  "apollo": {
    "main": {
      "full": "/art/characters/apollo_full.png",
      "medium": "/art/characters/apollo_medium.png",
      "thumb": "/art/characters/apollo_thumb.png"
    }
  },
  "ace": {
    "main": {
      "full": "/art/characters/ace_full.png",
      "medium": "/art/characters/ace_medium.png",
      "thumb": "/art/characters/ace_thumb.png"
    }
  },
  "kyo": {
    "main": {
      "full": "/art/characters/uncle_kyo_full.png",
      "medium": "/art/characters/uncle_kyo_medium.png",
      "thumb": "/art/characters/uncle_kyo_thumb.png"
    }
  },
  "uncle_khan": {
    "main": {
      "full": "/art/characters/uncle_khan_full.png",
      "medium": "/art/characters/uncle_khan_medium.png",
      "thumb": "/art/characters/uncle_khan_thumb.png"
    }
  },
  "kaleb": {
    "main": {
      "full": "/art/characters/kaleb_full.png",
      "medium": "/art/characters/kaleb_medium.png",
      "thumb": "/art/characters/kaleb_thumb.png"
    },
    "alts": {
      "kaleb_siren": {
        "medium": "/art/characters/kaleb_siren_medium.png",
        "thumb": "/art/characters/kaleb_siren_thumb.png"
      }
    }
  },
  "sebastian_vamp": {
    "main": {
      "full": "/art/characters/sebastian_vamp_full.png",
      "medium": "/art/characters/sebastian_vamp_medium.png",
      "thumb": "/art/characters/sebastian_vamp_thumb.png"
    }
  },
  "rio": {
    "main": {
      "full": "/art/characters/rio_full.png",
      "medium": "/art/characters/rio_medium.png",
      "thumb": "/art/characters/rio_thumb.png"
    }
  },
  "alyce_char": {
    "main": {
      "full": "/art/characters/alyce_full.png",
      "medium": "/art/characters/alyce_medium.png",
      "thumb": "/art/characters/alyce_thumb.png"
    },
    "alts": {
      "alyce_upset": {
        "medium": "/art/characters/alyce_upset_medium.png",
        "thumb": "/art/characters/alyce_upset_thumb.png"
      }
    }
  },
  "alexei": {
    "main": {
      "full": "/art/characters/alexei_full.png",
      "medium": "/art/characters/alexei_medium.png",
      "thumb": "/art/characters/alexei_thumb.png"
    },
    "alts": {
      "alexei_smile": {
        "medium": "/art/characters/alexei_smile_medium.png",
        "thumb": "/art/characters/alexei_smile_thumb.png"
      }
    }
  },
  "allie": {
    "main": {
      "full": "/art/characters/allie_full.png",
      "medium": "/art/characters/allie_medium.png",
      "thumb": "/art/characters/allie_thumb.png"
    }
  },
  "carole": {
    "main": {
      "full": "/art/characters/carole_full.png",
      "medium": "/art/characters/carole_medium.png",
      "thumb": "/art/characters/carole_thumb.png"
    },
    "alts": {
      "carole_red": {
        "medium": "/art/characters/carole_red_medium.png",
        "thumb": "/art/characters/carole_red_thumb.png"
      }
    }
  },
  "primrose": {
    "main": {
      "full": "/art/characters/primrose_full.png",
      "medium": "/art/characters/primrose_medium.png",
      "thumb": "/art/characters/primrose_thumb.png"
    }
  },
  "polly": {
    "main": {
      "full": "/art/characters/polly_full.png",
      "medium": "/art/characters/polly_medium.png",
      "thumb": "/art/characters/polly_thumb.png"
    }
  },
  "frau": {
    "main": {
      "full": "/art/characters/frau_full.png",
      "medium": "/art/characters/frau_medium.png",
      "thumb": "/art/characters/frau_thumb.png"
    }
  },
  "bradshaw": {
    "main": {
      "full": "/art/characters/bradshaw_full.png",
      "medium": "/art/characters/bradshaw_medium.png",
      "thumb": "/art/characters/bradshaw_thumb.png"
    }
  },
  "geo": {
    "main": {
      "full": "/art/characters/geo_full.png",
      "medium": "/art/characters/geo_medium.png",
      "thumb": "/art/characters/geo_thumb.png"
    }
  },
  "diana": {
    "main": {
      "full": "/art/characters/diana_full.png",
      "medium": "/art/characters/diana_medium.png",
      "thumb": "/art/characters/diana_thumb.png"
    }
  },
  "hades": {
    "main": {
      "full": "/art/characters/hades_full.png",
      "medium": "/art/characters/hades_medium.png",
      "thumb": "/art/characters/hades_thumb.png"
    },
    "alts": {
      "hades_alt": {
        "medium": "/art/characters/hades_alt_medium.png",
        "thumb": "/art/characters/hades_alt_thumb.png"
      }
    }
  },
  "hercules": {
    "main": {
      "full": "/art/characters/hercules_full.png",
      "medium": "/art/characters/hercules_medium.png",
      "thumb": "/art/characters/hercules_thumb.png"
    }
  },
  "hermes": {
    "main": {
      "full": "/art/characters/hermes_full.png",
      "medium": "/art/characters/hermes_medium.png",
      "thumb": "/art/characters/hermes_thumb.png"
    }
  },
  "ares": {
    "main": {
      "full": "/art/characters/ares_full.png",
      "medium": "/art/characters/ares_medium.png",
      "thumb": "/art/characters/ares_thumb.png"
    },
    "alts": {
      "ares_alt": {
        "medium": "/art/characters/ares_alt_medium.png",
        "thumb": "/art/characters/ares_alt_thumb.png"
      }
    }
  },
  "erza": {
    "main": {
      "full": "/art/characters/erza_full.png",
      "medium": "/art/characters/erza_medium.png",
      "thumb": "/art/characters/erza_thumb.png"
    }
  },
  "trenton": {
    "main": {
      "full": "/art/characters/trenton_full.png",
      "medium": "/art/characters/trenton_medium.png",
      "thumb": "/art/characters/trenton_thumb.png"
    }
  },
  "ezra": {
    "main": {
      "full": "/art/characters/ezra_full.png",
      "medium": "/art/characters/ezra_medium.png",
      "thumb": "/art/characters/ezra_thumb.png"
    }
  },
  "brax": {
    "main": {
      "full": "/art/characters/brax_full.png",
      "medium": "/art/characters/brax_medium.png",
      "thumb": "/art/characters/brax_thumb.png"
    }
  },
  "ford": {
    "main": {
      "full": "/art/characters/ford_main_full.png",
      "medium": "/art/characters/ford_main_medium.png",
      "thumb": "/art/characters/ford_main_thumb.png"
    },
    "alts": {
      "ford_2nd": {
        "full": "/art/characters/ford_2nd_full.png",
        "medium": "/art/characters/ford_2nd_medium.png",
        "thumb": "/art/characters/ford_2nd_thumb.png"
      },
      "ford_annoyed": {
        "full": "/art/characters/ford_annoyed_full.png",
        "medium": "/art/characters/ford_annoyed_medium.png",
        "thumb": "/art/characters/ford_annoyed_thumb.png"
      },
      "ford_casual": {
        "full": "/art/characters/ford_casual_full.png",
        "medium": "/art/characters/ford_casual_medium.png",
        "thumb": "/art/characters/ford_casual_thumb.png"
      },
      "ford_relaxed": {
        "full": "/art/characters/ford_relaxed_full.png",
        "medium": "/art/characters/ford_relaxed_medium.png",
        "thumb": "/art/characters/ford_relaxed_thumb.png"
      }
    }
  },
  "vaughn": {
    "main": {
      "full": "/art/characters/vaughn_main_full.png",
      "medium": "/art/characters/vaughn_main_medium.png",
      "thumb": "/art/characters/vaughn_main_thumb.png"
    },
    "alts": {
      "vaughn_necklace": {
        "full": "/art/characters/vaughn_necklace_full.png",
        "medium": "/art/characters/vaughn_necklace_medium.png",
        "thumb": "/art/characters/vaughn_necklace_thumb.png"
      },
      "vaughn_wine": {
        "full": "/art/characters/vaughn_wine_full.png",
        "medium": "/art/characters/vaughn_wine_medium.png",
        "thumb": "/art/characters/vaughn_wine_thumb.png"
      }
    }
  },
  "juliette_fairy": {
    "main": {
      "full": "/art/characters/juliette_full.png",
      "medium": "/art/characters/juliette_medium.png",
      "thumb": "/art/characters/juliette_thumb.png"
    }
  },
  "cyrus_fairy": {
    "main": {
      "full": "/art/characters/cyrus_main_full.png",
      "medium": "/art/characters/cyrus_main_medium.png",
      "thumb": "/art/characters/cyrus_main_thumb.png"
    },
    "alts": {
      "cyrus_annoyed": {
        "full": "/art/characters/cyrus_annoyed_full.png",
        "medium": "/art/characters/cyrus_annoyed_medium.png",
        "thumb": "/art/characters/cyrus_annoyed_thumb.png"
      },
      "cyrus_cold": {
        "full": "/art/characters/cyrus_cold_full.png",
        "medium": "/art/characters/cyrus_cold_medium.png",
        "thumb": "/art/characters/cyrus_cold_thumb.png"
      },
      "cyrus_hair": {
        "full": "/art/characters/cyrus_hair_full.png",
        "medium": "/art/characters/cyrus_hair_medium.png",
        "thumb": "/art/characters/cyrus_hair_thumb.png"
      },
      "cyrus_relaxed": {
        "full": "/art/characters/cyrus_relaxed_full.png",
        "medium": "/art/characters/cyrus_relaxed_medium.png",
        "thumb": "/art/characters/cyrus_relaxed_thumb.png"
      },
      "cyrus_shirtless_wings": {
        "full": "/art/characters/cyrus_shirtless_wings_full.png",
        "medium": "/art/characters/cyrus_shirtless_wings_medium.png",
        "thumb": "/art/characters/cyrus_shirtless_wings_thumb.png"
      },
      "cyrus_wings": {
        "full": "/art/characters/cyrus_wings_full.png",
        "medium": "/art/characters/cyrus_wings_medium.png",
        "thumb": "/art/characters/cyrus_wings_thumb.png"
      }
    }
  },
};

export function getCharacterArt(charId, size = 'medium') {
  const art = CHARACTER_ART[charId];
  if (!art?.main) return null;
  return art.main[size] || art.main.medium || null;
}

export function getCharacterAlts(charId) {
  return CHARACTER_ART[charId]?.alts || null;
}

export { CHARACTER_ART };
